import React, { Component, } from "react";
import { message, Spin } from "antd";
import * as app from "../core/app";
import { RouterView } from "../router";

export default class App extends Component {

  state = {
    loading: true,
  };

  componentDidMount() {
    app.initApp().then(() => {
      this.setState({
        ...this.state,
        loading: false,
      });
    }).catch(res => {
      res = res || {};
      res.message && message.error(res.message);
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="app-loading">
          <Spin tip="加载资源中……" />
        </div>
      );
    }
    return (
      <RouterView />
    );
  }
}

